/**
 * Color Themes
 *
 * @summary Color Themes
 * @author Dominik Haas-Artho
 *
 * Created at     : 2021-01-26 16:11:52
 * Last modified  : 2021-01-26 09:16:01
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const colors = ['#71c5bd', '#FFD740', '#00897b', '#35a89d', '#8ae0de', '#ffc107', '#ff847b', '#92e5ef'];

export const lightColorblind = {
  primary: '#00897b',
  secondary: '#35a89d',
  highlight: '#71c5bd',
  accent: '#ffd740',
  success: '#8ae0de',
  warning: '#ffc107',
  error: '#ff847b',
  errorHighlight: '#ffb060',
  info: '#92e5ef',
};

export const gradients = {
  lightGreenBlue: {
    from: '#d6ff7f',
    to: '#00b3cc',
  },
  violetBlueTurkis: {
    from: '#9055ff',
    to: '#13e2da',
  },
  darkToLighTurkis: {
    from: '#402565',
    to: '#30be96',
  },
  blueLightToBrigth: {
    from: '#2f80ed',
    to: '#b2ffda',
  },
};
